import { service } from './index';
import _ from 'lodash';
export const name = 'URL.render';
const URL_REGX = /(^(http|https):\/\/.*)|(^\/\/.*)/;
function formatUrl(uri) {
    const isUrl = URL_REGX.test(uri);
    return isUrl ? uri : `//${uri}`;
}
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    return [
        // @ts-ignore
        <div class="xtable-cell-render" attrs={attrs}>
            <a href={formatUrl(row[column.property])} target="_blank">
                {row[column.property]}
            </a>
        </div>,
    ];
}
// 可编辑激活模板
function renderEdit(h, renderOpts, params) {
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    const editor = (
    // @ts-ignore
    <div class="xtable-cell-editor" attrs={attrs}>
            {/* @ts-ignore */}
            <textarea onchange={e => service.updateCellValue(row, column, _.trim(e.target.value))} maxlength="4000">
                {row[column.property]}
            </textarea>
        </div>);
    this.$nextTick(() => {
        service.updateEditorRect(editor, row, column);
    });
    return [editor];
}
// 可编辑显示模板
const renderCell = renderDefault;
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
// 校验
function validator(uri) {
    return _.isEmpty(uri) || (_.isString(uri) && uri.length <= 4000);
}
export default {
    renderDefault,
    renderEdit,
    renderCell,
    exportMethod,
    validator,
};
